exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".styles_container__2oxA9 {\n  min-height: calc(100vh - 60px);\n  background-color: #3E3E3E; }\n", ""]);

// Exports
exports.locals = {
	"container": "styles_container__2oxA9"
};